export const rovingIndexForKey = ({
  key,
  currentIndex,
  itemCount,
  orientation,
}: {
  readonly key: string;
  readonly currentIndex: number;
  readonly itemCount: number;
  readonly orientation: "horizontal" | "vertical";
}): number | null => {
  if (itemCount <= 0 || currentIndex < 0 || currentIndex >= itemCount) return null;
  if (key === "Home") return 0;
  if (key === "End") return itemCount - 1;
  const previous = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
  const next = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
  if (key === previous) return currentIndex === 0 ? itemCount - 1 : currentIndex - 1;
  if (key === next) return currentIndex === itemCount - 1 ? 0 : currentIndex + 1;
  return null;
};

export const moveFocusWithin = ({
  container,
  target,
  key,
  selector,
  orientation,
}: {
  readonly container: HTMLElement;
  readonly target: EventTarget | null;
  readonly key: string;
  readonly selector: string;
  readonly orientation: "horizontal" | "vertical";
}): boolean => {
  if (!(target instanceof Element)) return false;
  const current = target.closest<HTMLElement>(selector);
  if (current === null) return false;
  const items = [...container.querySelectorAll<HTMLElement>(selector)].filter((item) => !item.hasAttribute("disabled"));
  const nextIndex = rovingIndexForKey({ key, currentIndex: items.indexOf(current), itemCount: items.length, orientation });
  if (nextIndex === null) return false;
  items[nextIndex]?.focus();
  return true;
};
